/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import FeatureItemCard from '../../Elements/FeatureItemCard/FeatureItemCard';
import FeatureItems from '../../Elements/FeatureItem/FeatureItems';
import FeatureHeader from '../../Elements/Header';
import FeatureButtonRow from '../../Elements/CtaButtons';
import Block from '@legacy-vfuk/core-block';
import SimpleGrid from '@legacy-vfuk/core-simple-grid';
import {
  imageBlock,
  imageContainer,
  assessmentPage,
  SimpleGridWrapper,
  ButtonWrapper,
  LinkWrapper,
  FeatureCardWrapper,
  whiteCSS,
  galleryCSS,
} from './styles/SectionFeatureRow.styles';
import { SectionFeatureRowProps } from './types/SectionFeatureRow.types';
import FeatureCardsWithIcon from '../../Elements/FeatureCardsWithIcon/FeatureCardsWithIcon';
import StyledLinkWithIcon from '../../Elements/LinkWithIcon/StyledLinkWithIcon';
import FeatureCardsWithIconTitle from '../../Elements/FeatureCardsWithIcon/FeatureCardsWithIconTitle';

const SectionFeatureRow = ({
  featureImage,
  featureHeader,
  featureItems,
  featureItemCards,
  featureButtons,
  featureCardsWithIcon,
  featureLink,
  featureCardsWithIconTitle,
  backgroundColor,
}: SectionFeatureRowProps) => {
  const backgroundCss = backgroundColor === 'white' ? whiteCSS : galleryCSS;
  const imageCss = [];
  let itemSpringSize: any;

  if (featureImage && featureImage.page === 'Assessment') {
    imageCss.push(assessmentPage);
    itemSpringSize = 'large';
  } else {
    imageCss.push(imageBlock);
    itemSpringSize = 'small';
  }

  function createLayout(totalItems: number) {
    if (totalItems % 2 === 0) {
      return Array(totalItems).fill(6);
    } else {
      const array = Array(totalItems - 1).fill(6);
      array.push(12);
      return array;
    }
  }

  return (
    <Block css={backgroundCss}>
      {featureImage && (
        <SimpleGridWrapper size={itemSpringSize}>
          <SimpleGrid
            columns={{
              sm: 1,
            }}
            justify="center"
            verticalAlign="center"
          >
            <div css={imageContainer}>
              <GatsbyImage
                image={getImage(featureImage.mainImage) as IGatsbyImageData}
                css={imageCss}
                alt={featureImage.name}
              />
            </div>
          </SimpleGrid>
        </SimpleGridWrapper>
      )}
      {featureHeader && (
        <SimpleGridWrapper size="large">
          <SimpleGrid
            columns={{
              sm: 1,
            }}
            justify="center"
            verticalAlign="center"
          >
            <FeatureHeader
              content={featureHeader}
              spacingLevel={featureHeader.noMargin ? { bottom: 0, top: 0 } : undefined}
            />
          </SimpleGrid>
        </SimpleGridWrapper>
      )}
      {featureItems.length > 0 && (
        <SimpleGridWrapper size="large">
          <SimpleGrid
            columns={{
              sm: 1,
              md: featureItems.length,
            }}
            verticalAlign="top"
          >
            {featureItems.map(item => {
              return <FeatureItems key={item.id} items={item} />;
            })}
          </SimpleGrid>
        </SimpleGridWrapper>
      )}
      {featureItemCards.length > 0 && (
        <SimpleGridWrapper size="large">
          <FeatureCardWrapper>
            <SimpleGrid
              layout={{
                sm: [12],
                md: createLayout(featureItemCards.length),
              }}
              spacing={7}
              verticalAlign="stretch"
            >
              {featureItemCards.map(item => {
                return <FeatureItemCard key={item.id} item={item} />;
              })}
            </SimpleGrid>
          </FeatureCardWrapper>
        </SimpleGridWrapper>
      )}
      {featureCardsWithIconTitle && (
        <SimpleGridWrapper size="large">
          <SimpleGrid
            columns={{
              sm: 1,
            }}
            justify="center"
            verticalAlign="center"
          >
            <FeatureCardsWithIconTitle
              title={featureCardsWithIconTitle.title}
            />
          </SimpleGrid>
        </SimpleGridWrapper>
      )}
      {featureCardsWithIcon.length > 0 && (
        <SimpleGridWrapper size="large">
          <FeatureCardWrapper>
            <SimpleGrid
              columns={{
                sm: 1,
                md: featureCardsWithIcon.length,
              }}
              spacing={7}
              verticalAlign="stretch"
              justify="center"
            >
              {featureCardsWithIcon.map(card => {
                return <FeatureCardsWithIcon key={card.id} card={card} />;
              })}
            </SimpleGrid>
          </FeatureCardWrapper>
        </SimpleGridWrapper>
      )}
      {featureButtons && (
        <ButtonWrapper>
          <FeatureButtonRow
            key={featureButtons.id}
            buttonRowAlignment={featureButtons.buttonRowAlignment}
            buttons={featureButtons.buttons}
            isMobileViewButtonOrderReversed={
              featureButtons.isMobileViewButtonOrderReversed
            }
          />
        </ButtonWrapper>
      )}
      {featureLink && (
        <SimpleGridWrapper size="small">
          <SimpleGrid
            columns={{
              sm: 1,
            }}
            justify="center"
            verticalAlign="center"
          >
            <LinkWrapper>
              <StyledLinkWithIcon
                key={featureLink.id}
                desktop={{
                  label: featureLink.desktopLabel,
                  appearance: featureLink.desktopAppearance,
                  inverse: featureLink.desktopInverse,
                  underline: featureLink.desktopUnderline,
                }}
                mobile={{
                  label: featureLink.mobileLabel,
                  appearance: featureLink.mobileAppearance,
                  inverse: featureLink.mobileInverse,
                  underline: featureLink.mobileUnderline,
                }}
                iconName={featureLink.iconName}
                targetSectionId={featureLink.targetSectionId}
              />
            </LinkWrapper>
          </SimpleGrid>
        </SimpleGridWrapper>
      )}
    </Block>
  );
};

export default SectionFeatureRow;
